module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "city-map"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentMap),
      expression: "currentMap"
    }],
    attrs: {
      "id": "map_picker"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentMap = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setCurrentMap]
    }
  }, [_c('option', {
    attrs: {
      "value": "Neighborhood Bounds"
    }
  }, [_vm._v("Neighborhood Bounds")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Total Crime"
    }
  }, [_vm._v("Total Crime")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Part 1 Crime"
    }
  }, [_vm._v("Part 1 (more serious) crime")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Part 2 Crime"
    }
  }, [_vm._v("Part 2 (less serious) crime")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Walk Score"
    }
  }, [_vm._v("Walk Score")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Bike Score"
    }
  }, [_vm._v("Bike Score")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Transit Score"
    }
  }, [_vm._v("Transit Score")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Arts Venues"
    }
  }, [_vm._v("Arts Venues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nightlife Venues"
    }
  }, [_vm._v("Nightlife Venues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Shops"
    }
  }, [_vm._v("Shops")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Outdoor and Recreation Venues"
    }
  }, [_vm._v("Outdoor and Recreation Venues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Food Venues"
    }
  }, [_vm._v("Food Venues")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "All Venues"
    }
  }, [_vm._v("All Venues")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "leafletMap"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d6b2e49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CityMap.vue
// module id = 182
// module chunks = 1